import React from 'react';
import CRUDList from '../Common/CRUDList';
import { passengers } from '../../services/api';

function PassengerForm({ formData, setFormData }) {
  return (
    <>
      <div className="form-group">
        <label>Passenger Name</label>
        <input
          type="text"
          value={formData.passenger_name || ''}
          onChange={(e) => setFormData({ ...formData, passenger_name: e.target.value })}
        />
      </div>
      <div className="form-group">
        <label>
          <input
            type="checkbox"
            checked={!!formData.passenger_is_def}
            onChange={(e) => setFormData({ ...formData, passenger_is_def: e.target.checked ? 1 : 0 })}
            style={{ marginRight: '8px' }}
          />
          This passenger is you
        </label>
      </div>
    </>
  );
}

function PassengersList() {
  return (
    <CRUDList
      title="Passengers"
      api={passengers}
      columns={['ID', 'Name', 'User', 'Is You']}
      FormComponent={PassengerForm}
      defaultFormData={{ passenger_name: '', passenger_is_def: 0 }}
      useOldStyle={true}
      renderRow={(item) => (
        <>
          <td>{item.passenger_id}</td>
          <td>{item.passenger_name || '-'}</td>
          <td>{item.user_login}</td>
          <td>{item.passenger_is_def ? 'Yes' : 'No'}</td>
        </>
      )}
    />
  );
}

export default PassengersList;
